import * as React from "react";
import ModalDelete from "../commons/components/modal/ModalDelete";
import ModalPopup from "../commons/components/modal/ModalPopup";
import Form from "../commons/components/form/Form";
import InputState from "../commons/model/form/InputState";
import MultiSelectCheckboxInput from "../commons/components/form/input/MultiSelectCheckboxInput";
import TextInput from "../commons/components/form/input/TextInput";
import { minChecked, required } from "../commons/model/form/Validators";
import sfetch from "../commons/utils/super-fetch";
import "./ModalModifyTeam.scss";
import SelectableOption from "../commons/model/SelectableOption";

interface ModalModifyTeamProps {
  endpoint: string;
  teamName: string;
  countries: SelectableOption[];
  close: (reload: boolean) => void;
}

interface ModalModifyTeamState {
  globalErrorMsg?: string;
  displayedModal: DisplayedModal;
}

enum DisplayedModal {
  MODIFY_TEAM = "MODIFY_TEAM",
  CONFIRM_DELETE_TEAM = "CONFIRM_DELETE_TEAM",
  CANT_DELETE_TEAM = "CANT_DELETE_TEAM",
}

// LongTermFix sjahan 19/06/20: Must be merged with ModalAddTeam
export default class ModalModifyTeam extends React.Component<
  ModalModifyTeamProps,
  ModalModifyTeamState
> {
  constructor(props: ModalModifyTeamProps) {
    super(props);
    this.confirm = this.confirm.bind(this);
    this.checkRemove = this.checkRemove.bind(this);
    this.remove = this.remove.bind(this);
    this.state = { displayedModal: DisplayedModal.MODIFY_TEAM };
  }

  private confirm(form: { [key: string]: InputState }): Promise<void> {
    const payload = {};
    payload["name"] = form["teamName"].value;
    payload["countries"] = form["countries"].value;

    return sfetch(this.props.endpoint, {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(() => this.props.close(true))
      .catch((response) => {
        if (response.status == 400) {
          this.setState({
            globalErrorMsg: i18n["Page.CustomerSupport.Error.BadRequest"],
          });
        }
      });
  }

  private checkRemove(): Promise<void> {
    return sfetch(this.props.endpoint, {
      method: "GET",
    })
      .then((response) => {
        response.json().then((team) => {
          if (team.users.length == 0) {
            this.setState({
              displayedModal: DisplayedModal.CONFIRM_DELETE_TEAM,
            });
          } else {
            this.setState({ displayedModal: DisplayedModal.CANT_DELETE_TEAM });
          }
        });
      })
      .catch(() => {
        this.setState({
          globalErrorMsg: i18n["Global.Status.technical_error"],
        });
      });
  }

  private remove(): Promise<void> {
    return sfetch(this.props.endpoint, {
      method: "DELETE",
    })
      .then(() => this.props.close(true))
      .catch((response) => {
        if (response.status == 400) {
          this.setState({
            globalErrorMsg: i18n["Page.CustomerSupport.Error.BadRequest"],
          });
        }
      });
  }

  render() {
    return (
      <>
        {this.state.displayedModal == DisplayedModal.MODIFY_TEAM && (
          <ModalPopup closeModal={() => this.props.close(false)} id="modal-modify-team">
            <div className="title">{i18n["Page.CustomerSupport.ModifyTeam.Title"]}</div>
            <Form
              titleLabel={i18n["Page.CustomerSupport.ModifyTeam.Title"]}
              submitLabel={i18n["Page.CustomerSupport.ModifyTeam.Submit"]}
              submit={this.confirm}
              generalErrorMsg={this.state.globalErrorMsg}
              secondaryActionLabel={i18n["Page.CustomerSupport.ModifyTeam.Remove"]}
              secondaryAction={this.checkRemove}
              secondaryActionClassName="danger"
            >
              <TextInput
                name="teamName"
                label={i18n["Page.CustomerSupport.Name"]}
                placeholder={i18n["Page.CustomerSupport.NamePlaceHolder"]}
                validators={[required()]}
                initialValue={this.props.teamName}
              />
              <MultiSelectCheckboxInput
                name="countries"
                label={i18n["Page.CustomerSupport.Countries"]}
                options={this.props.countries}
                validators={[minChecked(i18n["Form.Error.AtLeastOneValueIsRequired"], 1)]}
              />
            </Form>
          </ModalPopup>
        )}
        {this.state.displayedModal == DisplayedModal.CONFIRM_DELETE_TEAM && (
          <ModalDelete
            title={i18n["Page.CustomerSupport.DeleteTeam.Title"]}
            actionButtonLabel={i18n["Page.CustomerSupport.DeleteTeam.Submit"]}
            cancel={() => this.setState({ displayedModal: DisplayedModal.MODIFY_TEAM })}
            action={this.remove}
          >
            {i18n["Page.CustomerSupport.DeleteTeam.Description"]}
          </ModalDelete>
        )}
        {this.state.displayedModal == DisplayedModal.CANT_DELETE_TEAM && (
          <ModalPopup
            closeModal={() => this.setState({ displayedModal: DisplayedModal.MODIFY_TEAM })}
          >
            <div className="title">{i18n["Page.CustomerSupport.ModifyTeam.Title"]}</div>
            <div className="message">{i18n["Page.CustomerSupport.DeleteTeam.WithUsers"]}</div>
          </ModalPopup>
        )}
      </>
    );
  }
}
